import React from "react";
import { InfoText } from "./molecules/InfoText";
import { MainText } from "./molecules/MainText";
import { AvailableLoanOptionsIcon } from "../../atoms/icons/available-loan-options";
import { ViewAs } from "./molecules/ViewAs";
import { SortBy } from "./molecules/SortBy";
import { LoanTypeGrid } from "./molecules/LoanTypeGrid";
import { LoanTypeList } from "./molecules/LoanTypeList";
import { BottomBar } from "./molecules/BottomBar";
import { ShareLoanModal } from "./molecules/ShareLoanModal";
import { TopStatsBarDesktop } from "./molecules/TopStatsBarDesktop";

export const LoansDesktopView = ({
  hideTopBar,
  isGrid,
  setGrid,
  isComparedIds,
  setComparedId,
  sorting,
  setSorting,
  sortedLoans,
  setIsComparisonView,
  comparedQuotes,
  setDetails,
  showShareModal,
  setShowShareModal,
  onFormEdit,
  setShowSettingsModal,
  enteredData,
  content,
}) => {
  const { price, downPayment, zip, creditScore } = enteredData;

  return (
    <div className="irq-desktop">
      <ShareLoanModal
        open={showShareModal}
        onFormEdit={onFormEdit}
        onClose={() => setShowShareModal(false)}
      />

      <div className="irq-right-side-wrapper scrim">
        <InfoText tip={content.tooltipRateApr} />
      </div>

      {!hideTopBar && (
        <TopStatsBarDesktop
          creditScore={creditScore}
          downpayment={downPayment}
          price={price}
          zip={zip}
          setShowSettingsModal={setShowSettingsModal}
        />
      )}

      <div className="irq-main-section-wrapper gap">
        <div className="irq-main-section-info-text">
          <MainText />
          <div className="irq-middle-menu align-items-center">
            <div className="flex-row align-items-center">
              <AvailableLoanOptionsIcon className="margin-right" fill="white" />
              <div className="bold">Available Loan Options</div>
            </div>
            <div className="loan-option-controls-wrapper">
              <ViewAs isGrid={isGrid} setGrid={setGrid} />
              <SortBy sorting={sorting} setSorting={setSorting} />
            </div>
          </div>

          <div className="loan-types-stack">
            {sortedLoans && sortedLoans.length > 0 ? (
              sortedLoans.map((i) => {
                return isGrid ? (
                  <LoanTypeGrid
                    quotes={i.quotes}
                    loanTerm={i.loanTerm}
                    armFixedTermYears={i.armFixedTermYears}
                    key={i.id}
                    isComparedIds={isComparedIds}
                    setComparedId={setComparedId}
                    setDetails={setDetails}
                  />
                ) : (
                  <LoanTypeList
                    quotes={i.quotes}
                    loanTerm={i.loanTerm}
                    armFixedTermYears={i.armFixedTermYears}
                    key={i.id}
                    isComparedIds={isComparedIds}
                    setComparedId={setComparedId}
                    setDetails={setDetails}
                  />
                );
              })
            ) : (
              <div className="empty-state">
                No loans returned with specified parameters. Please try again.
              </div>
            )}
          </div>
        </div>
      </div>

      <BottomBar
        quotes={comparedQuotes}
        setIsComparisonView={setIsComparisonView}
      />
    </div>
  );
};
